import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Account from 'modules/Account';
import Layout from 'modules/Layout';
import SessionStorage from 'libs/SessionStorage';
import { LOGIN_REDIRECT_TO_KEY } from 'modules/App/constants';
function action({ route }) {
    SessionStorage.setItem(LOGIN_REDIRECT_TO_KEY, '/');
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        component: /*#__PURE__*/ _jsx(Layout.components.PlainLayout, {
            children: /*#__PURE__*/ _jsx(Account.components.SignOutSuccessStatement, {})
        })
    };
}
export default action;
